/* eslint-env browser */
import * as tgtag from './gtag';
import * as tfbp from './fbp';
import * as tli from './li';
import * as tvk from './vk';
import * as internal from './internal';
import * as tq from './quora';
import * as ttw from './twitter';
import * as rdt from './reddit';

const fullConfig = require('./config.json');

const availableTrackers = {
    gtag: tgtag,
    fbp: tfbp,
    li: tli,
    vk: tvk,
    internal,
    quora: tq,
    twitter: ttw,
    reddit: rdt,
};

const activeTrackers = [];
const pendingCalls = [];
let isInitialized = false;
let isInitializing = false;
let initializationScheduled = false;

function dispatch(method, args) {
    activeTrackers.forEach((tracker) => {
        try {
            tracker[method](...args);
        } catch (error) {
            // A broken third-party tracker must not block the rest of the queue.
            // eslint-disable-next-line no-console
            console.error(`Failed to send tracker ${method}`, error);
        }
    });
}

function flushPendingCalls() {
    const calls = pendingCalls.splice(0, pendingCalls.length);
    calls.forEach(({method, args}) => dispatch(method, args));
}

function init() {
    initializationScheduled = false;
    if (isInitialized || isInitializing) return;

    isInitializing = true;
    let {hostname} = window.location;
    hostname = hostname.toLowerCase();
    if (hostname.startsWith('www.')) {
        hostname = hostname.substring(4);
    }
    const accounts = fullConfig.accounts[hostname] || {};
    Object.entries(availableTrackers).forEach(([k, t]) => {
        const a = accounts[k];
        if (a || k === 'internal') {
            try {
                t.init(a, userInfo);
                activeTrackers.push(t);
            } catch (error) {
                // eslint-disable-next-line no-console
                console.error(`Failed to initialize tracker: ${k}`, error);
            }
        }
    });

    isInitializing = false;
    isInitialized = true;
    flushPendingCalls();
}

function scheduleInitialization() {
    if (isInitialized || isInitializing || initializationScheduled) {
        return;
    }

    initializationScheduled = true;

    const interactionEvents = ['scroll', 'touchstart', 'click', 'keydown', 'mousemove'];
    let timeoutId = null;

    const startTrackers = () => {
        if (timeoutId) {
            clearTimeout(timeoutId);
            timeoutId = null;
        }
        interactionEvents.forEach((evt) => {
            window.removeEventListener(evt, startTrackers);
        });

        if ('requestIdleCallback' in window) {
            window.requestIdleCallback(init);
        } else {
            window.setTimeout(init, 0);
        }
    };

    interactionEvents.forEach((evt) => {
        window.addEventListener(evt, startTrackers, {once: true, passive: true});
    });

    timeoutId = window.setTimeout(startTrackers, 5000);
}

function queueOrDispatch(method, args) {
    if (isInitialized) {
        dispatch(method, args);
        return;
    }

    pendingCalls.push({method, args});
    scheduleInitialization();
}

const userInfo = (info) => {
    let accumulatedInfo = localStorage.getItem('tracker.userInfo');
    accumulatedInfo = accumulatedInfo ? JSON.parse(accumulatedInfo) : {};
    Object.entries(info).forEach(([key, value]) => {
        if (value) {
            accumulatedInfo[key] = value;
        }
    });
    localStorage.setItem('tracker.userInfo', JSON.stringify(accumulatedInfo));

    queueOrDispatch('userInfo', [accumulatedInfo]);
};

function hit(url) {
    queueOrDispatch('hit', [url]);
}

function event(name) {
    queueOrDispatch('event', [name]);
}

if (typeof window !== 'undefined') {
    scheduleInitialization();
}

export {init, scheduleInitialization, userInfo, hit, event};
